import React from "react";
import styled from "styled-components";

const Title = styled.h1`
  font-weight: 500;
  font-size: 24px;
  line-height: 110%;
  margin-top: 0;
  color: black;
`;

const PageTitle = ({ children }) => <Title>{children}</Title>;

export default PageTitle;
